import { Button, DynamicMyoshLogo } from '@myosh/odin-components';
import { memo } from 'react';
import Settings from '../../components/header/settings.component';

const containerStyles = 'mx-auto my-0 flex h-screen w-full flex-col items-center justify-center';

interface ErrorPageProps {
  message: string;
  showHeader?: boolean;
  actionLabel?: string;
  onActionClick?: () => void;
}

const ErrorPage = ({ message, showHeader = true, actionLabel, onActionClick }: ErrorPageProps) => {
  return (
    <div data-cy="configuration-error" className="flex h-screen w-full flex-col">
      {showHeader && (
        <div
          data-cy="error-header-bar"
          className="sticky top-0 left-0 z-1300 mt-0 flex h-14 justify-between bg-background px-2 pt-2"
        >
          <DynamicMyoshLogo />
          <Settings showOnlyAboutOption />
        </div>
      )}
      <div className={containerStyles}>
        <span>{message}</span>
        {actionLabel && onActionClick && (
          <Button type="primary" onClick={onActionClick} style={{ marginTop: '12px' }} data-cy="reload">
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default memo(ErrorPage);
